import type {Schemas} from 'domainTypes/dto';
import type {Data} from 'schemaDefinition/types';
import type {DataResponse} from '../types';

export const mapFilterExportResponse = (
  dto: Schemas.ExportInformationResponse,
): DataResponse => {
  return {
    hits: dto.hits,
    rows: dto.rows.map(mapExportRow),
  };
};

const mapExportRow = (row: Schemas.ExportRow): Data => {
  const values: Data = {
    id: row.id,
  };

  row.columns.forEach(r => {
    if (r.values) {
      switch (r.column.type) {
        case 'NUMBER':
        case 'YEAR':
          values[r.column.name] = r.values.map(v => parseInt(v, 10));
          break;
        default:
          values[r.column.name] = r.values;
      }
    }
  });

  return values;
};
